import { UIEvent } from 'react';
import * as React from 'react';

import './SuggestionsSidebar.scss';
import ParagraphSuggestion from '../IssuePane/IssuePaneTabs/IssuePaneSuggestionTab/ParagraphSuggestions/ParagraphSuggestion/ParagraphSuggestion';
import {
    ISuggestionsSidebarProps,
    ISuggestionsSidebarState,
    LOAD_MORE_SUGGESTIONS_DISTANCE,
    PAGE_SIZE,
} from './SuggestionsSidebar-types';
import SuggestionResource from '../../resources/SuggestionResource';
import { mapSuggestion } from '../App/App-mappers';
import { debounce } from 'lodash';
import { Drawer } from '@thought-river/ui-components';

class SuggestionsSidebar extends React.Component<
    ISuggestionsSidebarProps,
    ISuggestionsSidebarState
> {
    private readonly listRef: React.RefObject<HTMLDivElement>;

    constructor(props: ISuggestionsSidebarProps) {
        super(props);

        this.state = {
            editedSuggestionId: null!, // Fixme: null checks
            loading: true,
            suggestions: [],
            suggestionCount: 0,
            pageNumber: 1,
        };

        this.listRef = React.createRef();
        this.onClose = this.onClose.bind(this);
    }

    componentDidUpdate(prevProps: ISuggestionsSidebarProps): void {
        if (this.props.show && !prevProps.show) {
            this.loadFirstPageOfSuggestions();
        }
    }

    private async loadFirstPageOfSuggestions() {
        const { contract, row } = this.props;

        if (row?.nonAssessedPropertyIds[0]) {
            this.setState({
                loading: true,
            });

            const suggestionData =
                await SuggestionResource.getSuggestionsAndTotalCountForProperty(
                    contract.streamCode,
                    row.nonAssessedPropertyIds[0],
                    1,
                    PAGE_SIZE
                );

            this.setState({
                loading: false,
                suggestions: suggestionData.suggestions.data.map(mapSuggestion),
                suggestionCount: suggestionData.count,
                pageNumber: 2,
            });
        }
    }

    private onScroll = (e: UIEvent<HTMLDivElement>) => {
        const { loading, suggestions, suggestionCount } = this.state;

        const isBottom =
            // @ts-ignore
            e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight <
            LOAD_MORE_SUGGESTIONS_DISTANCE;
        if (isBottom && suggestionCount > suggestions.length && !loading) {
            this.loadNextPage();
        }
    };

    private loadNextPage = debounce(async () => {
        const { contract, row } = this.props;

        const { loading, pageNumber, suggestions } = this.state;

        if (row?.nonAssessedPropertyIds[0] && !loading) {
            this.setState({
                loading: true,
            });

            const suggestionData =
                await SuggestionResource.getSuggestionsForProperty(
                    contract.streamCode,
                    row.nonAssessedPropertyIds[0],
                    pageNumber + 1,
                    PAGE_SIZE
                );

            this.setState({
                loading: false,
                suggestions: [
                    ...suggestions,
                    ...suggestionData.data.map(mapSuggestion),
                ],
                pageNumber: pageNumber + 1,
            });
        }
    }, 500);

    private onClose() {
        const { onCloseCallback } = this.props;

        this.setState({
            editedSuggestionId: null!, // Fixme: null checks
        });

        onCloseCallback();
    }

    render() {
        const { onSuggestionSelectedCallback, row, show, width } = this.props;

        const { editedSuggestionId, loading, suggestions } = this.state;

        return (
            <Drawer
                data-id="suggestions-sidebar"
                onClose={this.onClose}
                open={show}
                width={width}
                title={row?.title}
            >
                <div
                    className="suggestions-sidebar-inner-wrapper"
                    data-id="sidebar-inner-wrapper"
                >
                    <div className="sidebar-content" data-id="sidebar-content">
                        <div
                            className="suggestions-list-wrapper"
                            ref={this.listRef}
                            onScroll={this.onScroll}
                        >
                            <div className="suggestions-list">
                                {suggestions.map((suggestion, i) => (
                                    <ParagraphSuggestion
                                        key={suggestion.id}
                                        editing={
                                            editedSuggestionId === suggestion.id
                                        }
                                        isSelected={
                                            row?.selectedSuggestion
                                                ? row.selectedSuggestion?.id ===
                                                  suggestion.id
                                                : i === 0
                                        }
                                        onClickCallback={(
                                            suggestionId: string
                                        ) => {
                                            this.setState({
                                                editedSuggestionId:
                                                    suggestionId,
                                            });
                                        }}
                                        onSuggestionSelectedCallback={() =>
                                            onSuggestionSelectedCallback(
                                                suggestion
                                            )
                                        }
                                        suggestion={suggestion}
                                        suggestionNumber={i + 1}
                                    />
                                ))}
                                {loading && (
                                    <div className="loading-more-wrapper">
                                        <span className="loader" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

export default SuggestionsSidebar;
